import { __extends } from "tslib";
import * as React from 'react';
import * as propTypes from 'prop-types';
var TableContextProvider = /** @class */ (function (_super) {
    __extends(TableContextProvider, _super);
    function TableContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableContextProvider.prototype.getChildContext = function () {
        return {
            colWidths: this.props.colWidths
        };
    };
    TableContextProvider.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    TableContextProvider.tableContextTypes = {
        colWidths: propTypes.arrayOf(propTypes.string)
    };
    TableContextProvider.childContextTypes = TableContextProvider.tableContextTypes;
    return TableContextProvider;
}(React.Component));
export { TableContextProvider };
//# sourceMappingURL=provider.js.map